import { motion } from "framer-motion";

const wrap = { hidden: {}, show: { transition: { staggerChildren: 0.13, delayChildren: 0.15 } } };
const line = { hidden: { y: "112%" }, show: { y: "0%", transition: { duration: 0.7, ease: [0.22, 0.61, 0.36, 1] } } };
const fade = { hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0, transition: { duration: 0.55, delay: 0.5 } } };

export default function Hero({ onStart }) {
  return (
    <section className="hero" data-testid="hero">
      <motion.div
        className="hero-foto"
        initial={{ opacity: 0, y: 20, rotate: 8 }}
        animate={{ opacity: 1, y: 0, rotate: 4, transition: { duration: 0.55, delay: 0.7 } }}
      >
        <img src={`${process.env.PUBLIC_URL}/assets/img/foto-inicio.jpg`} alt="" aria-hidden="true" />
      </motion.div>
      <div className="hero-grid">
        <motion.div className="hero-copy" variants={wrap} initial="hidden" animate="show">
          <motion.p className="eyebrow" variants={fade}>
            <span className="mk-estrella" aria-hidden="true" /> Brand deal calculator
          </motion.p>
          <h1 className="hero-title display" data-testid="hero-title">
            <span className="lr"><motion.span className="lr-in" variants={line}>Tu <span className="marcador">tarifa</span> en</motion.span></span>
            <span className="lr"><motion.span className="lr-in" variants={line}>6 preguntas.</motion.span></span>
          </h1>
          <motion.p className="hero-sub" variants={fade}>
            Cuánto cobrar por crear y postear un video. La publicidad, el whitelisting y los derechos
            de imagen se cotizan aparte.
          </motion.p>
          <motion.div variants={fade}>
            <button type="button" className="btn btn-cta" onClick={onStart} data-testid="hero-cta">
              Empezar <span className="mk-estrella" aria-hidden="true" />
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
